<template>
  <section class="head">
    <div class="head-top">
      <div class="clearfix" style="max-width: 1377px;margin: 0px auto;">
        <a-row type="flex" justify="space-between">
          <div>
            <div class="logo"></div>
            <div class="menu">
              <ul>
               
                <li>
                  <a
                   @click="goHome"
                    class="link-menu"
                    event-label="菜单_帮助文档"
                    style="text-decoration: none;color: #41BC4C;border-bottom: 2px solid #41BC4C;"
                    >Help Center</a
                  >
                </li>
              </ul>
            </div>
          </div>
        
        </a-row>
      </div>
    </div>

  </section>
</template>

<script>
let setCookie = function(c_name, value, expiredays) {
  var exdate = new Date();
  exdate = exdate.getTime() + expiredays;
  exdate = new Date(exdate);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    ";path=/";
};
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },

  data() {
    return {
      showExtend: false,
      baseUrl: window.location.href.slice("help")[0],
      // baseUrl: process.env.VUE_APP_BASE_API,
      active: false,
    };
  },
  activated() {},
  methods: {
    goHome() {
     this.$router.push("/");
    },
    setActive() {
      this.active = false;
      if (this.$route) {
        console.log("this.$route", this.$route);
      }
    },
    eventHrefDemo() {
      setCookie("DEMOCLINET", "web3", 3600 * 1000);
    },
    setHrefDemo() {
      let _a = document.getElementById("HrefDemo");
      var demoUlr = _a.getAttribute("href");
      var regArr = /service=(.*)&access_key/g.exec(demoUlr);
      if (regArr[1]) {
        var decodeUrl = decodeURIComponent(regArr[1]);
        if (decodeUrl.indexOf("?") == -1) {
          decodeUrl = decodeUrl + "?clinet=web3_help&rewrite=off";
        } else {
          decodeUrl = decodeUrl + "&clinet=web3_help&rewrite=off";
        }
        demoUlr = demoUlr.replace(regArr[1], encodeURIComponent(decodeUrl));
        console.log("_a", _a, demoUlr);
        _a.setAttribute("href", demoUlr);
        console.log("_a", _a, demoUlr);
      }
    },
  },
};
</script>
<style>
@import "../assets/main.css";
</style>
